"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyProfile = void 0;
var React = __importStar(require("react"));
function MyProfile(props) {
    return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 30, viewBox: "0 0 30 30" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "a", x: 9.99, y: 5.001, width: 12.02, height: 12.063, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: 1, dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "b" }),
                React.createElement("feFlood", { floodOpacity: 0.329 }),
                React.createElement("feComposite", { operator: "in", in2: "b" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("filter", { id: "c", x: 6.7, y: 14.854, width: 18.6, height: 11.147, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: 1, dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "d" }),
                React.createElement("feFlood", { floodOpacity: 0.329 }),
                React.createElement("feComposite", { operator: "in", in2: "d" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("linearGradient", { id: "e", x1: 0.5, x2: 0.5, y2: 1, gradientUnits: "objectBoundingBox" },
                React.createElement("stop", { offset: 0, stopColor: "#ffa700" }),
                React.createElement("stop", { offset: 1, stopColor: "#ffc31f" })),
            React.createElement("filter", { id: "f", x: 7.99, y: 3.501, width: 12.02, height: 12.063, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: -1, dy: -1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "g" }),
                React.createElement("feFlood", { floodColor: "#fff" }),
                React.createElement("feComposite", { operator: "in", in2: "g" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("linearGradient", { id: "h", x1: 0.5, x2: 0.5, y2: 1, gradientUnits: "objectBoundingBox" },
                React.createElement("stop", { offset: 0, stopColor: "#0080ff" }),
                React.createElement("stop", { offset: 1, stopColor: "#0030fa" })),
            React.createElement("filter", { id: "i", x: 4.7, y: 13.354, width: 18.6, height: 11.147, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: -1, dy: -1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "j" }),
                React.createElement("feFlood", { floodColor: "#fff" }),
                React.createElement("feComposite", { operator: "in", in2: "j" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { transform: "translate(14738 15724)" },
            React.createElement("g", { transform: "translate(-14822 -16108)" },
                React.createElement("g", { transform: "translate(90 390)", fill: "#3d4c76", stroke: "#707070", strokeWidth: 1, opacity: 0 },
                    React.createElement("rect", { width: 18, height: 18, stroke: "none" }),
                    React.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, fill: "none" })),
                React.createElement("g", { transform: "translate(91.2 390.001)" },
                    React.createElement("g", { transform: "translate(0 0)" },
                        React.createElement("g", { transform: "matrix(1, 0, 0, 1, -7.2, -6)", filter: "url(#a)" },
                            React.createElement("ellipse", { cx: 4.418, cy: 4.397, rx: 4.418, ry: 4.397, transform: "translate(10.49 14.83) rotate(-88.51)", fill: "#3d4c76" })),
                        React.createElement("g", { transform: "matrix(1, 0, 0, 1, -7.2, -6)", filter: "url(#c)" },
                            React.createElement("path", { d: "M1207.609,1037.952h12.472A1.567,1.567,0,0,0,1221.6,1036l-1.135-4.535a1.659,1.659,0,0,0-1.3-1.227l-2.272-.42a1.009,1.009,0,0,0-.9.284l-1.643,1.664a.7.7,0,0,1-.993,0l-1.643-1.664a1.009,1.009,0,0,0-.719-.3,1,1,0,0,0-.184.017l-2.272.42a1.659,1.659,0,0,0-1.3,1.227l-1.135,4.535a1.567,1.567,0,0,0,1.516,1.949Z", transform: "translate(-1198.84 -1013.95)", fill: "#3d4c76" })),
                        React.createElement("g", { transform: "matrix(1, 0, 0, 1, -7.2, -6)", filter: "url(#f)" },
                            React.createElement("ellipse", { cx: 4.418, cy: 4.397, rx: 4.418, ry: 4.397, transform: "translate(10.49 14.83) rotate(-88.51)", fill: "url(#e)" })),
                        React.createElement("g", { transform: "matrix(1, 0, 0, 1, -7.2, -6)", filter: "url(#i)" },
                            React.createElement("path", { d: "M1207.609,1037.952h12.472A1.567,1.567,0,0,0,1221.6,1036l-1.135-4.535a1.659,1.659,0,0,0-1.3-1.227l-2.272-.42a1.009,1.009,0,0,0-.9.284l-1.643,1.664a.7.7,0,0,1-.993,0l-1.643-1.664a1.009,1.009,0,0,0-.719-.3,1,1,0,0,0-.184.017l-2.272.42a1.659,1.659,0,0,0-1.3,1.227l-1.135,4.535a1.567,1.567,0,0,0,1.516,1.949Z", transform: "translate(-1198.84 -1013.95)", fill: "url(#h)" }))))),
            React.createElement("rect", { width: 30, height: 30, transform: "translate(-14738 -15724)", fill: "none" }))));
}
exports.MyProfile = MyProfile;
//# sourceMappingURL=MyProfile.js.map